import { BRAND_LIST, CountryLanguageSwitcher, Languages } from 'typings'
import * as Typings from '../typings'

const NetherlandsLocale: Typings.LocaleType = {
  IS_EU: true,
  REGION: Typings.RegionGroupNames.OTHER,
  CODE: 'nl',

  LONG_NAME: 'Netherlands',
  SHORT_NAME: 'NL',

  DISPLAY_COUNTRY: 'Netherlands',

  LANGUAGES: {
    EN: 'en',
    NL: 'nl',
  },

  [BRAND_LIST.UQ]: {
    [Languages.NL]: {
      LANGUAGE_CODE: 'nl',
      DISPLAY_NAME: 'Netherlands (Dutch)',
      HOME_PAGE_URL: 'https://www.uniqlo.com/nl/nl',
      MAP_MOBILE_URL: 'https://map.uniqlo.com/nl/nl/',
      CONTACT_US_URL: 'https://faq-nl.uniqlo.com/pkb_Home_UQ_NL?l=nl_NL',
      TERMS_OF_USE_URL:
        'https://faq-nl.uniqlo.com/pkb_Home_UQ_NL?l=nl_NL&c=category_uq_be_nl%3AUQNL_C7_3',
      PRIVACY_POLICY_URL:
        'https://faq-nl.uniqlo.com/pkb_Home_UQ_NL?l=nl_NL&c=category_uq_be_nl%3AUQNL_C7_2',
      AREAS: {
        '1': 'Groningen',
        '2': 'Friesland',
        '3': 'Officieel Fryslân',
        '4': 'Drenthe',
        '5': 'Overijssel',
        '6': 'Flevoland',
        '7': 'Gelderland',
        '8': 'Utrecht',
        '9': 'Noord-Holland',
        '10': 'Zuid-Holland',
        '11': 'Zeeland',
        '12': 'Noord-Brabant',
        '13': 'Limburg',
      },
    },
    [Languages.EN]: {
      LANGUAGE_CODE: 'en',
      DISPLAY_NAME: 'Netherlands (English)',
      CONTACT_US_URL: 'https://faq-nl.uniqlo.com/',
      HOME_PAGE_URL: 'https://www.uniqlo.com/nl/en',
      MAP_MOBILE_URL: 'https://map.uniqlo.com/nl/en/',
      TERMS_OF_USE_URL:
        'https://faq-nl.uniqlo.com/pkb_Home_UQ_NL?l=en_US&c=category_uq_be_nl%3AUQNL_C7_3',
      PRIVACY_POLICY_URL:
        'https://faq-nl.uniqlo.com/pkb_Home_UQ_NL?l=en_US&c=category_uq_be_nl%3AUQNL_C7_2',
      AREAS: {
        '1': 'Groningen',
        '2': 'Friesland',
        '3': 'Officieel Fryslân',
        '4': 'Drenthe',
        '5': 'Overijssel',
        '6': 'Flevoland',
        '7': 'Gelderland',
        '8': 'Utrecht',
        '9': 'Noord-Holland',
        '10': 'Zuid-Holland',
        '11': 'Zeeland',
        '12': 'Noord-Brabant',
        '13': 'Limburg',
      },
    },
  },

  GEO_COORDINATES: {
    INITIAL_LATITUDE: 52.2129919,
    INITIAL_LONGITUDE: 5.2793703,
    INITIAL_ZOOM: 6,
    INITIAL_ZOOM_DETAILS_PAGE: 15,
  },

  // MAP_URL: '',

  POSTCODE_FORMAT: /^(?:NL-)?(\d{4})\s*([A-Z]{2})$/i,

  CLIENT_ID: {
    [BRAND_LIST.UQ]: '',
  },

  SHOW_COUNTRY_LANGUAGE_MODAL: {
    [BRAND_LIST.UQ]: CountryLanguageSwitcher.HEADER_SWITCHER_MODAL,
    [BRAND_LIST.GU]: CountryLanguageSwitcher.ALL_DISABLED,
    [BRAND_LIST.PL]: CountryLanguageSwitcher.ALL_DISABLED,
  },

  ONE_TRUST_FOOTER: {
    [BRAND_LIST.UQ]: true,
  },
}

export default NetherlandsLocale
